import { gql } from "@apollo/client";

/**
 * A payee's zones whose name matches `search` (an ILIKE pattern), for search-as-you-type zone
 * pickers. Scoped via zones' payee_account_id computed field -- app_user can't select (and so
 * can't filter on) zones.client_id. Capped well under app_user's 100-row limit on zones, since
 * the search narrows the set rather than paging through it.
 */
export const SEARCH_PAYEE_ZONES = gql`
  query SearchPayeeZones($payeeAccountId: uuid!, $search: String!) {
    zones(
      where: { payee_account_id: { _eq: $payeeAccountId }, name: { _ilike: $search } }
      order_by: [{ name: asc }, { id: asc }]
      limit: 50
    ) {
      id
      name
    }
  }
`;

export interface ZoneOption {
  id: string;
  name: string;
}

export interface SearchPayeeZonesData {
  zones: ZoneOption[];
}

export interface SearchPayeeZonesVars {
  payeeAccountId: string;
  search: string;
}

export default SEARCH_PAYEE_ZONES;
